import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import dayjs from 'dayjs';
import React from 'react';
import { ExtraListName } from '../../../Dashboard/widgets/orders/OrdersTodayWidget/SmsInboundModal';
import './LineHaulInfoTable.scss';
import { ParcelsLineHaulCount } from '../../../../types/statsTypes';

export function LineHaulInfoTable({
  parcelsLineHaulSummary,
}: {
  parcelsLineHaulSummary: ParcelsLineHaulCount[];
}): JSX.Element {
  return (
    <div className="LinehaulInfoTable">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{'LINEHAUL'}</TableCell>
              <TableCell>{'FIRST SCAN'}</TableCell>
              <TableCell>{'TOTAL'}</TableCell>
              <TableCell>{'IN CAGE'}</TableCell>
              <TableCell>{'REMAINING'}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parcelsLineHaulSummary.map(
              (obj: ParcelsLineHaulCount, i: number) => {
                return (
                  <TableRow key={i}>
                    <TableCell>
                      {obj.lineHaulName ? obj.lineHaulName : ExtraListName}
                    </TableCell>
                    <TableCell>
                      {obj.lineHaulFirstScan
                        ? dayjs(obj.lineHaulFirstScan).format('hh.mm')
                        : 'N/A'}
                    </TableCell>
                    <TableCell>{obj.lineHaulParcelsScansToDoForDate}</TableCell>
                    <TableCell>{obj.lineHaulParcelsScansDoneForDate}</TableCell>
                    <TableCell>
                      {obj.lineHaulParcelsScansToDoForDate -
                        obj.lineHaulParcelsScansDoneForDate}
                    </TableCell>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
